<template>
  <div class="page-payment">
    <Overlay width="x-small" autoHeight :link="{name: 'payment-methods'}">
      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"
      />

      <AddPaymentMethodForm
        v-if="stripeLoaded"
        @createPaymentMethod="createPaymentMethod"
        :showDefaultOption="true"
        :paymentBtnLoading="paymentBtnLoading"
        :stripe="stripe"
        :siteId="siteId"
        :companyId="companyId"
        :customer="customer"
      />
    </Overlay>
  </div>
</template>

<script>
import {readStripeCustomerData} from '@/lib/payments/customers'

import {
  attachCustomerPaymentMethodData,
  setDefaultCustomerPaymentMethod
} from '@/lib/payments/payment_methods'

import {loadStripe} from '@stripe/stripe-js'

import notification from '@/mixins/notification'
import page from '@/mixins/page'

import Overlay from '@/components/Overlay'
import AddPaymentMethodForm from '@/components/forms/AddPaymentMethodForm'

export default {
  name: 'create-payment-method',

  data() {
    return {
      title: 'Add Payment Method',
      customer: {},
      stripe: {},
      paymentBtnLoading: false,
      stripeLoaded: false,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
    }
  },

  mixins: [notification, page],

  props: {
    siteId: String,
    companyId: String
  },

  components: {
    Overlay,
    AddPaymentMethodForm
  },

  computed: {
    returnQuery() {
      return this.$route.query.returnPath
    }
  },

  methods: {
    getData() {
      readStripeCustomerData(this.companyId)
        .then(({data}) => {
          this.customer = data
        })
        .catch((response) => {
          this.triggerNotification('error', 'customer', 'not found')
        })
    },

    createCard() {
      this.card = this.elements.create('card', {style: this.style})
      this.mountCard()
    },

    mountCard() {
      this.card.mount('#card-element')
    },

    createPaymentMethod(card, name, setAsDefault) {
      this.paymentBtnLoading = true

      this.stripe
        .createPaymentMethod({
          type: 'card',
          card: card,
          billing_details: {
            name: name
          }
        })
        .then((result) => {
          if (result.error) {
            let message = result.error.message.replace('.', '')
            this.triggerNotification('error', 'card', message)
            this.paymentBtnLoading = false
          } else {
            let methodId = {
              payment_method_id: result.paymentMethod.id
            }

            // Attach payment method to customer
            attachCustomerPaymentMethodData(this.companyId, methodId).then(() => {
              if (setAsDefault) {
                // Set as default
                setDefaultCustomerPaymentMethod(this.companyId, methodId).then(() => {
                  this.triggerNotification('success', 'default card', 'added')
                })
              } else {
                this.triggerNotification('success', 'card', 'added')
              }

              this.paymentBtnLoading = false
            })

            window.setTimeout(() => {
              if (this.returnQuery) {
                this.$router.push({path: this.returnQuery})
              } else {
                this.$router.push({name: 'payment-methods'})
              }
            }, this.closeDelay)
          }
        })
    }
  },

  mounted() {
    loadStripe(this.publishableKey).then((result) => {
      this.stripe = result
      this.stripeLoaded = true
    })

    this.getData()
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.card-field
  margin-bottom: $gap-medium
  border: 1px solid $color-border
  border-radius: 3px
  padding-left: 5px
  margin-top: $gap-x-small

  iframe
    box-shadow: none
</style>
